import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import querystring from 'query-string'
import "whatwg-fetch"
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import ConnectButtonForm from "../../common/ConnectButtonForm";
import { connect } from "react-redux";

@connect(state => ({}), dispatch => ({
    dispatch
}))
class KakaoStoryPlusForm extends Component {

	componentDidMount() {
		const { plugin, data, onChange } = this.props
		if (!plugin.active) {
			onChange(update(data, {
				validated: {
					$set: !!data.setting.oAuthConsumerInfo
				}
			}))
		}
	}

	@autobind
	handleConnect() {
		const { data, onChange, dispatch } = this.props
		try {
			Kakao.init(data.setting.oAuthProviderInfo.consumer_key);
		} catch (ignore) {}


		Kakao.Auth.selectStoryChannel({
			success: response => {
				let extendedToken = response.extended_token
				let channelId = response.channel_id

				if (extendedToken && channelId) {
					fetch("/oauth/kakaostory", {
						method: 'post',
						credentials: "include",
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						},
						body: querystring.stringify({
							extendedToken: extendedToken,
							channelId: channelId
						})
					})
						.then(jsonResponseHandler(dispatch))
						.then(r => r.json())
						.then(json => {
							if (json.error) {
								alert(json.data)
							} else {
								onChange(update(data, {
									setting: {
										oAuthConsumerInfo: {
											$set: json.data
										}
									},
									validated: {
										$set: true
									}
								}))
							}
						})
						.catch(e => {
							console.error(e)
							alert('카카오스토리 채널 ID 연결을 실패하였습니다.')
						})
				} else {
					alert('카카오스토리 채널 ID 연결을 실패하였습니다.')
				}
			},
			fail: function(error) {
				console.error(error)
				alert('카카오스토리 채널 ID 연결을 실패하였습니다.')
			}
		});
	}

	render() {
		const { data, plugin } = this.props
		return (
			<div className="desc_plugin32">
				<p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

				<div className="wrap_btn">
					<ConnectButtonForm connected={!!data.setting.oAuthConsumerInfo} onClick={this.handleConnect} />
					<span className="txt_other">연결 페이지가 보이지 않으시면 브라우저의 팝업 허용 여부를 확인해 주세요.</span>
				</div>

				<div className="info_pluginline">
					<strong className="tit_set">설정 방법</strong>
					<ol className="list_plugin">
						<li>
							<span className="txt_em">1</span>
							계정 연결하기로 글이 발행될 스토리채널 ID를 연결해 주세요.
						</li>
						<li>
							<span className="txt_em">2</span>
							스토리채널에 가입되지 않은 경우 스토리채널에 가입해 주세요.
						</li>
						<li>
							<span className="txt_em">3</span>
							발행할 채널을 선택해 주세요.
							<a href="https://ch.kakao.com/about" target="_blank" className="link_other">채널 개설하러 가기</a>
						</li>
					</ol>
				</div>
                {this.props.saveButton()}
			</div>
		)
	}
}

KakaoStoryPlusForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default KakaoStoryPlusForm
